import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 5em 0;
    background-color: #F3F3F3;

    &:nth-child(even) {
        background-color: #ffffff;
    }

    .article-boxes {
        margin: 3em 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 2em 1em;

        .public-layout-articles-medium-article-box {
            max-width: 24.5em;
        }
    }

    .layout-button {
        padding-top: 2.5em;
    }

    @media all and (max-width: ${variables.mobileM}) {
        .article-boxes {
            justify-content: center;
            .public-layout-articles-medium-article-box {
                min-height: 0;
            }
        }
    }

`;